export const setItem = async (key, item, type) => {
  if (type === 'session') {
    return sessionStorage.setItem(key, JSON.stringify(item));
  }
  return localStorage.setItem(key, JSON.stringify(item));
};

export const getItem = async (key, type) => {
  if (type === 'session') {
    return JSON.parse(sessionStorage.getItem(key));
  }
  return JSON.parse(localStorage.getItem(key));
};

export const removeItem = async (key, type) => {
  if (type === 'session') {
    return sessionStorage.removeItem(key);
  }
  return localStorage.removeItem(key);
};



export const loadFromLocalStorage = (key, defaultValue) => {
  try {
    const serializedState = localStorage.getItem(key);
    return serializedState ? JSON.parse(serializedState) : defaultValue;
  } catch (e) {
    console.error("Could not load awards from local storage", e);
    return defaultValue;
  }
};

export const saveToLocalStorage = (key, data) => {
  try {
    const serializedState = JSON.stringify(data);
    localStorage.setItem(`${key}`, serializedState);
  } catch (e) {
    console.error("Could not save data to local storage", e);
  }
};
